/* KH configuratore PRODOTTI (VONDOM) — stesso look del configuratore piastrelle (kh-config-v3.css).
   Gestisce N opzioni Shopify (Cuscino, Misura/Dimensioni, Struttura-finitura...) = uno step ciascuna,
   + Colore Struttura/Tessuto dal metafield. NON riscrive la logica: costruisce #khCfg e nasconde i vecchi selettori. */
(function(){
  if(!window.KH_PCFG) return;
  var VARS=window.KH_VVARIANTS||[], OPTS=window.KH_VOPTS||[], COL=window.KH_VCOLORI||{};
  if(!VARS.length) return;
  var euro=function(c){ var pp=(c/100).toFixed(2).split('.'); return pp[0].replace(/\B(?=(\d{3})+(?!\d))/g,'.')+','+pp[1]+' €'; };

  /* TUTTE le opzioni Shopify che variano = uno step ciascuna */
  function optVals(o){ var s={},out=[]; (o.values||[]).forEach(function(v){ if(v&&!s[v]){s[v]=1;out.push(v);} }); return out; }
  var VOPTS=OPTS.filter(function(o){ return optVals(o).length>1; });
  var strutturaOpt=VOPTS.filter(function(o){ return /struttura/i.test(o.name||''); })[0]||null;
  var misuraOpt=VOPTS.filter(function(o){ return /misur|dimension|formato|\bsize\b/i.test(o.name||''); })[0]||null;
  /* ANGOLO box doccia: se il FORMATO contiene sia "Porta" che "Parete" -> Porta = scelta primaria,
     Parete = add-on opzionale (secondo articolo in carrello, stessa finitura). */
  var ANG_PORTA=[], ANG_PARETE=[], ANGOLO=false;
  if(misuraOpt){ optVals(misuraOpt).forEach(function(v){ if(/porta/i.test(v)) ANG_PORTA.push(v); else if(/parete/i.test(v)) ANG_PARETE.push(v); }); ANGOLO = ANG_PORTA.length>0 && ANG_PARETE.length>0; }
  /* box doccia (porta/parete): le immagini finitura sono render a tutto campo -> devono RIEMPIRE la card (cover), non contain */
  var ISDOCCIA = ANG_PORTA.length>0 || ANG_PARETE.length>0;
  function vfield(v,pos){ return pos===1?v.o1:(pos===2?v.o2:v.o3); }
  /* opzioni "colore/finitura" -> swatch con immagine della variante (es. IMEX: ogni finitura ha la sua foto) */
  function isSwatchOpt(o){ return /colore|finitur|materiale/i.test(o && o.name || ''); }
  function variantImgFor(o, val){
    var best='';
    for(var i=0;i<VARS.length;i++){ var v=VARS[i]; if(vfield(v,o.pos)!==val || !v.img) continue;
      var match=true;
      for(var j=0;j<VOPTS.length;j++){ var p=VOPTS[j].pos; if(p===o.pos) continue; if(state.opts[p]!=null && vfield(v,p)!==state.opts[p]){ match=false; break; } }
      if(match) return v.img; if(!best) best=v.img;
    }
    return best;
  }
  /* mappa nome-colore/finitura -> hex o gradiente (per swatch senza immagine: Capannoli/Arcadia/HomeUp) */
  var KH_CM={"bianco lucido":"#ffffff","nero lucido":"#1a1a1a","ocra lucido":"#c8a951","phard lucido":"#d4a89a","bianco matt":"#f0efe8","basalto matt":"#4a4a4a","brina matt":"#c8cfd4","londra matt":"#7a8a8a","foglia matt":"#6b8e5a","nero matt":"#2d2d2d","nocciola matt":"#8b6f47","bianco":"#ffffff","nero":"#1a1a1a","cemento":"#999999","sabbia":"#c8b88a","grigio":"#888888","avorio":"#f5f0e1","tortora":"#8b7d6b","antracite":"#333333","grigio antracite":"#333333","beige":"#d4c5a9","crema":"#f5e6c8","natural":"#c8b88a","white":"#ffffff","black":"#1a1a1a","grey":"#888888","marrone":"#6b4a2b","ruggine":"#8b4513",
    "cromo":"linear-gradient(135deg,#e8e8e8,#a8a8a8 50%,#d4d4d4)","cromo lucido":"linear-gradient(135deg,#e8e8e8,#a8a8a8 50%,#d4d4d4)","cromo / riflettente (mirror)":"linear-gradient(135deg,#e8e8e8,#888888 50%,#d8d8d8)","cromo / satinato":"linear-gradient(135deg,#c8c8c8,#9a9a9a 50%,#bababa)","cromo / trasparente":"linear-gradient(135deg,#D9D2C5,#b0b0b0 50%,#d0d0d0)",
    "nero satinato":"linear-gradient(135deg,#2a2a2a,#0d0d0d 50%,#1f1f1f)","bianco satinato":"linear-gradient(135deg,#ffffff,#d4d4d4 50%,#D9D2C5)",
    "nichel spazzolato":"linear-gradient(135deg,#b4b4ac,#7e7e74 50%,#a0a098)","nichel satinato":"linear-gradient(135deg,#b4b4ac,#7e7e74 50%,#a0a098)","nichel matt":"linear-gradient(135deg,#bcbcb4,#8a8a80 50%,#ababa3)",
    "oro":"linear-gradient(135deg,#d8b04f,#9a7820 50%,#c19a3a)","oro spazzolato":"linear-gradient(135deg,#d8b04f,#9a7820 50%,#c19a3a)","oro satinato opaco":"linear-gradient(135deg,#c9a850,#9a7820 50%,#b8933a)","oro rosa":"linear-gradient(135deg,#d4a08a,#a06868 50%,#b76e79)","oro rosa spazzolato":"linear-gradient(135deg,#d4a08a,#a06868 50%,#b76e79)","oro rosa opaco":"linear-gradient(135deg,#c99080,#906060 50%,#a86e70)",
    "ottone satinato":"linear-gradient(135deg,#c9b063,#8a7420 50%,#b59a3a)","bronzo satinato":"linear-gradient(135deg,#a9803f,#6a4d20 50%,#8a6a30)","bronzo satinato opaco":"linear-gradient(135deg,#8f6a35,#5a4020 50%,#75552a)","bronzo scuro":"#5b4326","rame satinato":"linear-gradient(135deg,#d49050,#8a5020 50%,#b87333)","rame spazzolato":"linear-gradient(135deg,#d49050,#8a5020 50%,#b87333)",
    "canna fucile lucido":"linear-gradient(135deg,#4a4a52,#26262c 50%,#3a3a42)","canna fucile satinato lucido":"linear-gradient(135deg,#44444a,#26262c 50%,#36363c)","canna fucile satinato opaco":"#33333a",
    "acciaio spazzolato":"linear-gradient(135deg,#c0c0c0,#888888 50%,#a8a8a8)","acciaio satinato":"linear-gradient(135deg,#c0c0c0,#888888 50%,#a8a8a8)","acciaio lucido":"linear-gradient(135deg,#D9D2C5,#a0a0a0 50%,#c8c8c8)","acciaio inox":"linear-gradient(135deg,#c8c8c8,#909090 50%,#b0b0b0)","acciaio s.316":"linear-gradient(135deg,#c8c8c8,#909090 50%,#b0b0b0)","nichel spazzolato ":"#b4b4ac","black gun metal":"#2b2e33",
    "noir pvd":"#1a1a1a","champagne pvd":"#e6d3a3","grigio champagne":"#cbb78f","rosè pvd":"#e8c0c0","rosé pvd":"#e8c0c0","blu oceano":"#1a5a6b","blu oceano opaco":"#1a5a6b","rosa corallo":"#e8836b","grigio cobalto":"#5a6470","moka":"#5a4030",
    "ral9010":"#f1ede1","ral9005":"#0a0a0a","ral1015":"#e6d2b5","ral7044":"#cac4b0","ral7024":"#474a50","ral2013":"#8b4a2b","ral3013":"#a12312","ral2000":"#ed760e","ral1032":"#ddaf27","ral3012":"#cb8d73","ral6021":"#89ac76","ral6003":"#424632","ral5020":"#06414d","ral5011":"#1a2c42","ral5024":"#5d9b9b"};
  ['graphite:#3a3a3a','grafite:#3a3a3a','graphit:#3a3a3a','manhattan:#7d7d7d','pergamon:#ede4d0','bahamabeige:#d9c9a8','bahama:#d9c9a8','verde:#3a7d5a','green:#3a7d5a','smeraldo:#2e8b57','caffè:#5a4030','caffe:#5a4030','ambra:#d8a04f','mandarino:#e8863a','arancione:#e8863a','orange:#e8863a','fumé:#6e6e6e','fume:#6e6e6e','cristallo:#dfeef0','trasparente:#dfeef0','blu:#27334a','blue:#27334a','argento:#c9ccce','silver:#c9ccce','rame:#b87333','copper:#b87333','rosa:#e8a0b4','pink:#e8a0b4','cipria:#e8b8b0','red:#c0392b','rosso:#c0392b','titanio:#2a2a2a','cromato:linear-gradient(135deg,#e8e8e8,#a8a8a8 50%,#d4d4d4)'].forEach(function(s){ var i=s.indexOf(':'); KH_CM[s.slice(0,i)]=s.slice(i+1); });
  function swatchColor(name){
    var n=(name||'').toLowerCase().trim();
    if(KH_CM[n]) return KH_CM[n];
    var ral=n.match(/ral\s*(\d{4})/); if(ral && KH_CM['ral'+ral[1]]) return KH_CM['ral'+ral[1]];
    var strp=n.replace(/\(.*?\)/g,'').replace(/^[0-9a-z]{3}\s*-\s*/,'').replace(/ral\s*\d{4}/,'').replace(/\b(opaco|lucido|satinato|matt|mat|glossy|brillante|spazzolato|lcc|active|clean|coat|laufen)\b/g,'').replace(/\s+/g,' ').trim();
    if(KH_CM[strp]) return KH_CM[strp];
    var words=n.split(/[^a-z0-9à-ÿ]+/);
    for(var i=0;i<words.length;i++){ if(KH_CM[words[i]]) return KH_CM[words[i]]; if(KH_HX[words[i]]) return KH_HX[words[i]]; }
    return '';
  }
  function isNone(c){ return !c || /^nessun/i.test(c); }
  /* immagini-etichetta dei colori STRUTTURA (gruppi non-Tessuto): servono a distinguere,
     nei gruppi Tessuto, le voci-struttura duplicate dai veri colori fodera */
  var STRUCT_IMGS={};
  Object.keys(COL).forEach(function(k){ if(!/^tessuto/i.test(k)){ (COL[k]||[]).forEach(function(c){ if(c&&c.variant_image) STRUCT_IMGS[c.variant_image]=1; }); } });
  /* opzione che "guida" i colori tessuto: i suoi valori corrispondono ai gruppi "Tessuto <valore>"
     del metafield (puo' chiamarsi Cuscino, Tessuto, Versione...). Cosi' i divani/lounge/pouf con
     opzione "Tessuto" mostrano i colori, e i tavoli con gruppi-spazzatura senza opzione NON li mostrano. */
  var TESSUTO_KEYS=Object.keys(COL).filter(function(k){return /^tessuto/i.test(k);}).map(function(k){return k.replace(/^Tessuto\s+/i,'');});
  var fabricOpt=VOPTS.filter(function(o){ return optVals(o).some(function(v){ return TESSUTO_KEYS.indexOf(v)>-1; }); })[0]||null;
  function tessutoGroupNow(){ if(!fabricOpt) return null; var val=state.opts[fabricOpt.pos]; if(!val||isNone(val)) return null; var g=COL['Tessuto '+val]; return (g&&g.length)?g:null; }

  /* colori struttura di base (gruppo dedicato, o hex nei Tessuto, o dagli scatti-colore) */
  var strutturaKey=Object.keys(COL).filter(function(k){ return !/^tessuto/i.test(k); })[0]||null;
  var KH_HX={'white':'#FFFFFF','black':'#0E0E10','ecru':'#C5B9AD','tortora':'#8C857A','gray':'#7D878F','grey':'#7D878F',
    'anthracite':'#4F4B48','brown':'#4F3529','garnet':'#683431','green':'#5F7975','cream':'#E5D8C6','blue':'#27334A',
    'camel':'#C2A487','clay':'#9D432C','ice':'#F2F2F2','ocean':'#1A6B7A','steel':'#7D878F','beige':'#cbb894',
    'jade':'#00a86b','red':'#c22','bronze':'#b08d57','pearl':'#eae0c8','dune':'#d2b48c','mustard':'#cca227',
    'olive':'#7d7842','peach':'#e7b48f','mint':'#a5d6b5','sand':'#cbb894','granite':'#a8a39f','stone':'#a8a39f',
    'navy':'#1b2a4a','gold':'#c9a227','silver':'#c9ccce','champagne':'#e6d3a3','chocolate':'#4b3227','turquoise':'#40c4c4','pink':'#e8a0b4','basalt':'#4a4a4a'};
  function titleCase(s){ return s.replace(/\b\w/g,function(m){return m.toUpperCase();}); }
  function structuraColors(){
    if(strutturaKey && COL[strutturaKey] && COL[strutturaKey].length) return COL[strutturaKey];
    var seen={}, out=[];
    Object.keys(COL).forEach(function(k){ (COL[k]||[]).forEach(function(c){ if(c && /^#/.test(c.swatch||'') && !seen[c.name]){ seen[c.name]=1; out.push(c); } }); });
    if(out.length) return out;
    var ims=(window.productData&&window.productData.images)||[]; var s2={}, o2=[];
    ims.forEach(function(im){ var u=(im&&(im.src||im.url))||im; if(typeof u!=='string') return;
      var fn=decodeURIComponent(u.split('/').pop().split('?')[0]).toLowerCase().replace(/\.[a-z0-9]+$/,'');
      var toks=fn.split(/[^a-z0-9]+/);
      for(var i=toks.length-1;i>=0;i--){ var tk=toks[i]; if(KH_HX[tk] && !s2[tk]){ s2[tk]=1; o2.push({name:titleCase(tk), swatch:KH_HX[tk], variant_image:u}); break; } }
    });
    return o2;
  }
  var STRUTT = window.KH_PCFG_VONDOM ? structuraColors() : [];  /* "Colore Struttura" solo VONDOM (metafield) */
  /* colori struttura CORRENTI: se c'e' l'opzione finitura e il metafield ha il gruppo per quella finitura, usalo */
  function strutturaGroupNow(){
    if(strutturaOpt){ var g=COL[state.opts[strutturaOpt.pos]]; if(g&&g.length) return g; }
    return STRUTT;
  }

  var state={ opts:{}, struttura:null, tessuto:null, qty:1, parete:null };
  /* risolve la variante PARETE scelta (stesse opzioni della porta tranne il FORMATO) */
  function pareteVariant(){ if(!ANGOLO||!state.parete||!misuraOpt) return null;
    for(var i=0;i<VARS.length;i++){ var v=VARS[i]; if(vfield(v,misuraOpt.pos)!==state.parete) continue; var ok=true;
      for(var j=0;j<VOPTS.length;j++){ var p=VOPTS[j].pos; if(p===misuraOpt.pos) continue; if(state.opts[p]!=null && vfield(v,p)!==state.opts[p]){ ok=false; break; } }
      if(ok) return v; }
    return null; }
  /* valori Parete che hanno una variante reale per le opzioni (finitura) correnti */
  function pareteOptionsForFinitura(){ if(!ANGOLO||!misuraOpt) return [];
    return ANG_PARETE.filter(function(pvv){ for(var i=0;i<VARS.length;i++){ var v=VARS[i]; if(vfield(v,misuraOpt.pos)!==pvv) continue; var ok=true;
      for(var j=0;j<VOPTS.length;j++){ var p=VOPTS[j].pos; if(p===misuraOpt.pos) continue; if(state.opts[p]!=null && vfield(v,p)!==state.opts[p]){ ok=false; break; } }
      if(ok) return true; } return false; }); }
  function allOptsPicked(){ for(var j=0;j<VOPTS.length;j++){ if(state.opts[VOPTS[j].pos]==null) return false; } return true; }
  function currentVariant(){
    if(!allOptsPicked()) return null;
    for(var i=0;i<VARS.length;i++){ var v=VARS[i], ok=true;
      for(var j=0;j<VOPTS.length;j++){ var p=VOPTS[j].pos; if(vfield(v,p)!==state.opts[p]){ ok=false; break; } }
      if(ok) return v; }
    return null;
  }
  function priceForOptValue(o,val){
    for(var i=0;i<VARS.length;i++){ var v=VARS[i], ok=true;
      for(var j=0;j<VOPTS.length;j++){ var p=VOPTS[j].pos, want=(p===o.pos)?val:state.opts[p]; if(vfield(v,p)!==want){ ok=false; break; } }
      if(ok) return v.price; }
    for(var k=0;k<VARS.length;k++){ if(vfield(VARS[k],o.pos)===val) return VARS[k].price; }
    return null;
  }
  /* esiste una variante REALE per (o=val) date le opzioni GIA' scelte? (filtra le combo inesistenti) */
  function optHasVariant(o,val){
    for(var i=0;i<VARS.length;i++){ var v=VARS[i]; if(vfield(v,o.pos)!==val) continue; var ok=true;
      for(var j=0;j<VOPTS.length;j++){ var p=VOPTS[j].pos; if(p===o.pos) continue;
        if(state.opts[p]!=null && vfield(v,p)!==state.opts[p]){ ok=false; break; } }
      if(ok) return true; }
    return false;
  }

  function imgList(){ var a=(window.KH_ALLIMG||[]).slice(); return a.filter(Boolean); }
  function colorImg(name){ if(!name) return ''; var n=name.toLowerCase().replace(/[^a-z0-9]+/g,''); var a=imgList();
    for(var i=0;i<a.length;i++){ var fn=decodeURIComponent(a[i].split('/').pop().split('?')[0]).toLowerCase().replace(/\.[a-z0-9]+$/,''); if(fn.split(/[^a-z0-9]+/).indexOf(n)>-1) return a[i]; } return ''; }

  /* ---- UI ---- */
  var root=document.createElement('div'); root.id='khCfg';
  root.innerHTML=''
    +'<div id="khSecs"></div>'
    +'<div class="kh-recap" id="khRecap"></div>'
    +'<div class="kh-buy"><button class="kh-cta" id="khCta">'
    +'<span class="kh-cta-l"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>Aggiungi al carrello</span>'
    +'<span class="kh-cta-r"><span class="kh-cta-lbl" id="khTotLbl">TOTALE</span><span class="kh-cta-tot" id="khTot">—</span></span>'
    +'</button></div>';

  function secEl(id,title){ var s=document.createElement('div'); s.className='kh-sec'; s.id='khSec-'+id;
    s.innerHTML='<div class="kh-hd"><div class="t"><span class="kh-dot"></span>'+title+'</div><div class="pick" id="khPick-'+id+'"></div></div><div class="kh-body" id="khBody-'+id+'"></div>'; return s; }
  var secs=root.querySelector('#khSecs');
  /* ordine step: [Finitura] → Colore Struttura → [altre opzioni: Misura...] → [Cuscino] → Colore Tessuto → Quantità */
  var stepList=[];
  if(misuraOpt) stepList.push(['opt'+misuraOpt.pos, misuraOpt.name]);   /* Misura/Dimensioni = PRIMA scelta */
  if(strutturaOpt) stepList.push(['opt'+strutturaOpt.pos, strutturaOpt.name]);
  if(STRUTT.length) stepList.push(['struttura','Colore Struttura']);
  VOPTS.forEach(function(o){ if(o!==strutturaOpt && o!==fabricOpt && o!==misuraOpt) stepList.push(['opt'+o.pos, o.name]); });
  if(fabricOpt) stepList.push(['opt'+fabricOpt.pos, fabricOpt.name]);
  if(fabricOpt) stepList.push(['tessuto','Colore Tessuto']);
  stepList.push(['qty','Quantità']);
  stepList.forEach(function(o){ secs.appendChild(secEl(o[0],o[1])); });

  function show(id){ var e=document.getElementById('khSec-'+id); if(!e) return; e.classList.add('on'); e.style.maxHeight=e.scrollHeight+'px'; clearTimeout(e._mh); e._mh=setTimeout(function(){ if(e.classList.contains('on')) e.style.maxHeight='none'; },450); }
  function hide(id){ var e=document.getElementById('khSec-'+id); if(!e) return; e.classList.remove('on','done'); e.style.maxHeight=''; var p=document.getElementById('khPick-'+id); if(p) p.textContent=''; }
  function done(id,txt){ var p=document.getElementById('khPick-'+id); if(p) p.textContent=txt; var e=document.getElementById('khSec-'+id); if(e) e.classList.add('done'); }

  /* ---- rivelazione progressiva degli step (come piastrelle): parte aperto solo il primo,
     i successivi si aprono quando selezioni; cambiando uno step, i seguenti si richiudono ---- */
  var stepOrder=stepList.map(function(s){ return s[0]; });
  var builders={};
  VOPTS.forEach(function(o){ builders['opt'+o.pos]=function(){ buildOpt(o); }; });
  builders['struttura']=function(){ buildStruttura(); };
  builders['tessuto']=function(){ buildTessuto(); };
  builders['qty']=function(){ buildQty(); };
  function hideAfter(id){ var i=stepOrder.indexOf(id); for(var j=i+1;j<stepOrder.length;j++) hide(stepOrder[j]); }
  function clearAfter(id){ var i=stepOrder.indexOf(id);
    for(var j=i+1;j<stepOrder.length;j++){ var s=stepOrder[j];
      if(s.indexOf('opt')===0){ state.opts[+s.slice(3)]=null; }
      else if(s==='struttura'){ state.struttura=null; }
      else if(s==='tessuto'){ state.tessuto=null; }
    }
  }
  function revealFrom(idx){
    for(var j=idx;j<stepOrder.length;j++){ var nid=stepOrder[j]; if(builders[nid]) builders[nid]();
      var el=document.getElementById('khSec-'+nid); if(el && el.classList.contains('on')) return; }
  }
  function advance(id){ clearAfter(id); hideAfter(id); revealFrom(stepOrder.indexOf(id)+1); }

  /* ---- dropdown CUSTOM (stile configuratore, interno stilizzabile) ---- */
  var _khOpenDD=null;
  document.addEventListener('click', function(e){
    if(_khOpenDD && !_khOpenDD.contains(e.target)){ _khDDclose(_khOpenDD); }
  });
  function _khDDclose(w){ w.classList.remove('open'); var p=w.querySelector('.kh-dd-panel'); if(p) p.classList.remove('open');
    var sec=w._sec; if(sec) sec.style.overflow=''; if(_khOpenDD===w) _khOpenDD=null; }
  function khDropdown(cfg){
    var wrap=document.createElement('div'); wrap.className='kh-dd';
    var curItem=null; cfg.items.forEach(function(it){ if(it.value===(cfg.current||'')) curItem=it; });
    var curLabel=(curItem?curItem.label:(cfg.placeholder||'Seleziona…'));
    var trig=document.createElement('button'); trig.type='button'; trig.className='kh-dd-trigger';
    trig.innerHTML='<span class="kh-dd-cur">'+curLabel+'</span><span class="kh-dd-chev"><svg width="14" height="9" viewBox="0 0 14 9" fill="none" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 1l6 6 6-6"/></svg></span>';
    var panel=document.createElement('div'); panel.className='kh-dd-panel';
    cfg.items.forEach(function(it){
      var row=document.createElement('div'); row.className='kh-dd-opt'+(it.value===(cfg.current||'')?' sel':'');
      row.innerHTML='<span class="kh-dd-nm">'+it.label+'</span>'+(it.price!=null?('<span class="kh-dd-price">'+euro(it.price)+'</span>'):'');
      row.onclick=function(e){ e.stopPropagation();
        panel.querySelectorAll('.kh-dd-opt').forEach(function(x){x.classList.remove('sel');}); row.classList.add('sel');
        var cur=wrap.querySelector('.kh-dd-cur'); if(cur) cur.textContent=it.label;
        _khDDclose(wrap); cfg.onPick(it.value); };
      panel.appendChild(row);
    });
    trig.onclick=function(e){ e.stopPropagation();
      var willOpen=!wrap.classList.contains('open');
      if(_khOpenDD && _khOpenDD!==wrap) _khDDclose(_khOpenDD);
      if(willOpen){ wrap._sec=wrap.closest?wrap.closest('.kh-sec'):null; if(wrap._sec) wrap._sec.style.overflow='visible';
        wrap.classList.add('open'); panel.classList.add('open'); _khOpenDD=wrap; }
      else { _khDDclose(wrap); }
    };
    wrap.appendChild(trig); wrap.appendChild(panel);
    return wrap;
  }

  /* STEP opzione Shopify (Cuscino / Misura / Struttura-finitura...) */
  function buildOpt(o){
    var b=document.getElementById('khBody-opt'+o.pos); if(!b) return;
    var vals=optVals(o);
    if(ANGOLO && o===misuraOpt){ vals=vals.filter(function(v){ return /porta/i.test(v); }); } /* primaria = solo Porta */
    /* mostra solo i valori con una variante reale per le scelte precedenti (es. Struttura per la Misura scelta) */
    var vf=vals.filter(function(v){ return optHasVariant(o,v); }); if(vf.length) vals=vf;
    if(isSwatchOpt(o)){
      b.innerHTML='<div class="kh-swatches"></div>'; var wrapS=b.querySelector('.kh-swatches');
      vals.forEach(function(val){
        var img=variantImgFor(o,val); var col= img?'':swatchColor(val);
        var bg = img ? 'background:#F5F2EB' : (col ? ((col.indexOf('gradient')>-1?'background-image:'+col:'background:'+col)+';box-shadow:inset 0 0 0 1px rgba(0,0,0,.08)') : 'background:#eee');
        var el=document.createElement('div'); el.className='kh-sw';
        el.innerHTML='<div class="tick">✓</div><div class="th" style="'+bg+'">'+(img?'<img src="'+img+'" style="'+(ISDOCCIA?'object-fit:cover':'object-fit:contain;padding:6%')+'" onerror="this.style.display=\'none\'">':'')+'</div><div class="nm">'+val+'</div>';
        if(state.opts[o.pos]===val) el.classList.add('sel');
        el.onclick=function(){ wrapS.querySelectorAll('.kh-sw').forEach(function(x){x.classList.remove('sel');}); el.classList.add('sel');
          state.opts[o.pos]=val; done('opt'+o.pos,val); var im=variantImgFor(o,val); if(im) setShow(im,val,true);
          advance('opt'+o.pos); update(); };
        wrapS.appendChild(el);
      });
      show('opt'+o.pos); return;
    }
    /* molte opzioni (es. box doccia: tante misure di Porta) -> menu a tendina invece delle pill */
    if(vals.length>6){
      b.innerHTML='';
      var items=vals.map(function(val){ return {value:val, label:val, price:priceForOptValue(o,val)}; });
      b.appendChild(khDropdown({ items:items, current:(state.opts[o.pos]||''), placeholder:'Seleziona…',
        onPick:function(val){ if(!val) return; state.opts[o.pos]=val; done('opt'+o.pos,val); advance('opt'+o.pos); update(); } }));
      show('opt'+o.pos); return;
    }
    b.innerHTML='<div class="kh-pills"></div>'; var wrap=b.querySelector('.kh-pills');
    var prices=vals.map(function(v){ return priceForOptValue(o,v); }).filter(function(x){return x!=null;});
    var base=prices.length?Math.min.apply(null,prices):0;
    var cus=(o===fabricOpt);
    vals.forEach(function(val){
      var pr=priceForOptValue(o,val); var diff=(pr!=null)?pr-base:0;
      var el=document.createElement('div'); el.className='kh-pill';
      var tag = cus ? (diff>0?'+'+euro(diff):'incluso') : (pr!=null?euro(pr):'');
      el.innerHTML=val+(tag?'<small class="kh-mq">'+tag+'</small>':'');
      if(state.opts[o.pos]===val) el.classList.add('sel');
      el.onclick=function(){ wrap.querySelectorAll('.kh-pill').forEach(function(x){x.classList.remove('sel');}); el.classList.add('sel');
        state.opts[o.pos]=val; done('opt'+o.pos,val);
        advance('opt'+o.pos); update(); };
      wrap.appendChild(el);
    });
    show('opt'+o.pos);
  }

  /* texture reale del tessuto (swatch VONDOM colores/...) dalla mappa KH_FABRICTEX o dalla voce stessa */
  function fabTex(coll, c){
    var m=(window.KH_FABRICTEX||{})[(coll||'').toLowerCase()]; var mapped=m&&m[((c&&c.name)||'').toLowerCase()];
    if(mapped) return mapped;
    var sw=(c&&c.swatch)||''; if(/\/colores\//i.test(sw)) return sw;
    return '';
  }
  /* fabricColl != null => modalità tessuto: mostra la TEXTURE (mai la foto del divano); dove manca, pallina colore */
  function swatchGrid(bodyId, arr, selName, onpick, fabricColl){
    var b=document.getElementById(bodyId); if(!b) return; b.innerHTML='<div class="kh-swatches"></div>'; var wrap=b.querySelector('.kh-swatches');
    arr.forEach(function(c){
      var sw=c.swatch||''; var isHex=/^#/.test(sw); var thumb, bg='', onerr="this.style.display='none'";
      if(fabricColl){
        thumb=fabTex(fabricColl,c);
        var fbHex = isHex ? sw : (KH_HX[(c.name||'').toLowerCase()]||'#D9D2C5');
        if(!thumb) bg='background:'+fbHex;
        onerr="this.style.display='none';this.parentNode.style.background='"+fbHex+"'";  /* texture rotta -> colore pieno */
      } else {
        thumb=c.variant_image || (isHex?'':sw); if(isHex && !thumb) bg='background:'+sw;
      }
      var el=document.createElement('div'); el.className='kh-sw';
      el.innerHTML='<div class="tick">✓</div><div class="th" style="'+bg+'">'+(thumb?'<img src="'+thumb+'" onerror="'+onerr+'">':'')+'</div><div class="nm">'+c.name+'</div>';
      if(c.name===selName) el.classList.add('sel');
      el.onclick=function(){ wrap.querySelectorAll('.kh-sw').forEach(function(x){x.classList.remove('sel');}); el.classList.add('sel'); onpick(c); };
      wrap.appendChild(el);
    });
  }

  /* STEP Colore Struttura (dinamico in base alla finitura) */
  function buildStruttura(){
    var arr=strutturaGroupNow();
    if(!arr.length){ hide('struttura'); state.struttura=null; return; }
    swatchGrid('khBody-struttura', arr, state.struttura, function(c){ state.struttura=c.name; done('struttura',c.name); updateShow(c); advance('struttura'); update(); });
    show('struttura');
  }

  /* STEP Colore Tessuto (dipende dal cuscino) — solo tessuti VERI (swatch = immagine) */
  function buildTessuto(){
    var g=tessutoGroupNow();
    if(!g){ hide('tessuto'); state.tessuto=null; return; }
    var overlap=g.filter(function(c){ return c.variant_image && STRUCT_IMGS[c.variant_image]; }).length;
    var fab;
    if(overlap > g.length/2){ fab=g; }  /* imbottito: struttura=fodera -> mostra tutti i colori */
    else { fab=g.filter(function(c){ return !(c.variant_image && STRUCT_IMGS[c.variant_image]); }); if(!fab.length) fab=g; }
    if(state.tessuto && !fab.some(function(c){return c.name===state.tessuto;})) state.tessuto=null;
    var coll=fabricOpt?state.opts[fabricOpt.pos]:'';
    swatchGrid('khBody-tessuto', fab, state.tessuto, function(c){ state.tessuto=c.name; done('tessuto',c.name);
      var tex=fabTex(coll,c); if(tex) setShow(tex,'Tessuto '+c.name); advance('tessuto'); update(); }, coll);
    show('tessuto');
  }

  /* STEP Quantità */
  function buildQty(){
    var b=document.getElementById('khBody-qty');
    b.innerHTML='<div class="kh-qty"><button class="kh-qbtn" id="khMinus">−</button>'
      +'<div class="kh-qnum"><span id="khQ">'+state.qty+'</span><small id="khQUnit">'+(state.qty===1?'pezzo':'pezzi')+'</small></div>'
      +'<button class="kh-qbtn" id="khPlus">+</button></div>';
    b.querySelector('#khMinus').onclick=function(){ if(state.qty>1){state.qty--;update();} };
    b.querySelector('#khPlus').onclick=function(){ if(state.qty<99){state.qty++;update();} };
    show('qty');
  }

  /* prima immagine PRODOTTO: salta le ambientazioni (KH_AMBIENT) confrontando il nome-file */
  function firstShot(){
    var ims=(window.productData&&window.productData.images)||[];
    var amb={}; (window.KH_AMBIENT||[]).forEach(function(u){ amb[String(u).split('/').pop().split('?')[0]]=1; });
    for(var i=0;i<ims.length;i++){ var u=(ims[i]&&(ims[i].src||ims[i].url))||ims[i]; if(u && !amb[String(u).split('/').pop().split('?')[0]]) return u; }
    return ims[0]?(ims[0].src||ims[0].url||ims[0]):'';
  }
  function khShowFit(){
    var img=document.getElementById('khShowImg'), show=document.getElementById('khShow'); if(!img||!show) return;
    show.classList.remove('kh-plain');
    var nat=img.naturalWidth||0, need=(show.clientWidth||700)*(window.devicePixelRatio||1);
    if(nat && nat < need-40){ var cap=Math.round(nat*1.6); show.classList.add('kh-lowres'); img.style.maxWidth=cap+'px'; img.style.maxHeight=cap+'px'; }
    else { show.classList.remove('kh-lowres'); img.style.maxWidth=''; img.style.maxHeight=''; }
  }
  function khShowPlain(){
    var img=document.getElementById('khShowImg'), show=document.getElementById('khShow'); if(!img||!show) return;
    show.classList.remove('kh-lowres'); show.classList.add('kh-plain'); img.style.maxWidth=''; img.style.maxHeight='';
  }
  function setShow(src, cap, plain){
    var img=document.getElementById('khShowImg'); if(!img||!src) return;
    var fit = plain ? khShowPlain : khShowFit;
    var u=src+(src.indexOf('?')>-1?'&':'?')+'width=1200';
    if(img.getAttribute('src')!==u){
      img.onload=fit;
      img.onerror=function(){ img.onerror=null; var fb=strutImg()||firstShot(); if(fb){ img.src=fb; khShowPlain(); var bg2=document.getElementById('khShowBg'); if(bg2) bg2.src=fb; } };
      img.src=u; var bg=document.getElementById('khShowBg'); if(bg) bg.src=u;
    }
    else { fit(); }
    var cp=document.getElementById('khShowCap'); if(cp) cp.textContent=cap||'';
  }
  /* immagine prodotto di default: primo colore struttura (foto prodotto), MAI l'ambientazione */
  function strutImg(){ var s=strutturaGroupNow()||[]; for(var i=0;i<s.length;i++){ var u=colorImg(s[i].name)||s[i].variant_image; if(u) return u; } return ''; }
  function updateShow(c){
    var src = (c && (colorImg(c.name)||c.variant_image)) || colorImg(state.struttura) || strutImg() || firstShot() || (window.KH_ALLIMG&&window.KH_ALLIMG[0]) || '';
    setShow(src, state.struttura||'', true);
  }

  /* ---- PIN sticky ---- */
  var khBox=null, khTk=false, khTopCache=-1;
  function khStick(){
    var showc=document.querySelector('.fx-product-showcase'); if(!showc) return;
    var content=document.querySelector('.fx-product-content'); var visual=showc.parentNode;
    var khShow=document.getElementById('khShow'); if(!content||!visual||!khShow) return;
    var ph=document.getElementById('khShowcasePh');
    if(!ph){ ph=document.createElement('div'); ph.id='khShowcasePh'; ph.style.display='none'; visual.insertBefore(ph, showc); }
    if(window.innerWidth<900){ showc.style.position=''; showc.style.top=''; showc.style.left=''; showc.style.width=''; showc.style.margin=''; showc.style.zIndex=''; khShow.style.height=''; ph.style.display='none'; return; }
    if(khTopCache<0){
      var _hh=0, _sels=['.Header','.site-header','[data-section-type=header]','.Header__Wrapper','.shopify-section-header','header'];
      for(var _si=0;_si<_sels.length;_si++){ var _els=document.querySelectorAll(_sels[_si]); for(var _ei=0;_ei<_els.length;_ei++){ var _e=_els[_ei], _cs=getComputedStyle(_e), _r=_e.getBoundingClientRect(); if((_cs.position==='fixed'||_cs.position==='sticky') && _r.top<=1 && _r.height>_hh) _hh=_r.height; } }
      if(_hh>0) khTopCache=Math.round(_hh)+14;
    }
    var TOP = khTopCache>0 ? khTopCache : 14;
    var targetH = Math.max(240, Math.round(window.innerHeight - TOP - 18 - 210))+'px';
    if(khShow.style.height!==targetH) khShow.style.height=targetH;
    var pinned = showc.style.position==='fixed';
    var natTop = pinned ? ph.getBoundingClientRect().top : showc.getBoundingClientRect().top;
    var cRect = content.getBoundingClientRect();
    var h = pinned ? ph.offsetHeight : showc.offsetHeight;
    if(natTop<=TOP){
      if(!khBox){ var r=showc.getBoundingClientRect(); khBox={left:Math.round(r.left), width:Math.round(r.width)}; }
      ph.style.display='block'; ph.style.height=h+'px'; ph.style.width=khBox.width+'px';
      var topPos=Math.min(TOP, Math.round(cRect.bottom - h));
      showc.style.position='fixed'; showc.style.top=topPos+'px'; showc.style.left=khBox.left+'px'; showc.style.width=khBox.width+'px'; showc.style.margin='0'; showc.style.zIndex='6';
    } else {
      showc.style.position=''; showc.style.top=''; showc.style.left=''; showc.style.width=''; showc.style.margin=''; showc.style.zIndex=''; ph.style.width='';
      ph.style.display='none'; khBox=null;
    }
  }
  function khStickReq(){ if(khTk) return; khTk=true; requestAnimationFrame(function(){ khTk=false; khStick(); }); }
  function khOnResize(){ khBox=null; khTopCache=-1; var s=document.querySelector('.fx-product-showcase'); if(s){ s.style.position=''; s.style.left=''; s.style.width=''; } khStickReq(); }

  /* add-on "parete laterale" (solo box doccia ad angolo) */
  function buildAngolo(){
    if(!ANGOLO || document.getElementById('khAngolo')) return;
    var wrap=document.createElement('div'); wrap.id='khAngolo'; wrap.style.cssText='display:none;margin:2px 0 0';
    wrap.innerHTML='<div style="border:1.5px dashed #2D5A3D;border-radius:12px;padding:12px 14px;background:rgba(45,90,61,0.04);font-family:\'Jost\',sans-serif">'
      +'<label style="display:block;font-size:0.82rem;font-weight:700;color:#2D5A3D;margin-bottom:7px;font-family:inherit">Doccia ad angolo? Aggiungi la parete laterale</label>'
      +'<div id="khAngDD"></div>'
      +'<p style="font-size:0.72rem;color:#6b7280;margin:7px 0 0;line-height:1.4;font-family:inherit">Aggiunta al carrello nella stessa finitura, come secondo articolo.</p>'
      +'</div>';
    /* sopra lo step Quantità (se presente), altrimenti prima del recap */
    var qtySec=document.getElementById('khSec-qty');
    if(qtySec && qtySec.parentNode){ qtySec.parentNode.insertBefore(wrap, qtySec); }
    else { var rc=document.getElementById('khRecap'); root.insertBefore(wrap, rc); }
  }
  function refreshAngolo(){
    var wrap=document.getElementById('khAngolo'); if(!wrap) return;
    var ready=currentVariant()!=null;
    wrap.style.display=ready?'block':'none';
    if(!ready){ state.parete=null; return; }
    var dd=document.getElementById('khAngDD'); if(!dd) return;
    var opts=pareteOptionsForFinitura(), want=opts.join('||');
    if(dd._want===want) return; dd._want=want;
    var cur=state.parete; if(cur && opts.indexOf(cur)<0){ cur=null; state.parete=null; }
    var items=[{value:'', label:'Nessuna (solo porta)', price:null}];
    opts.forEach(function(pvv){ var variant=null;
      for(var i=0;i<VARS.length;i++){ if(vfield(VARS[i],misuraOpt.pos)!==pvv) continue; var ok=true;
        for(var j=0;j<VOPTS.length;j++){ var p=VOPTS[j].pos; if(p===misuraOpt.pos) continue; if(state.opts[p]!=null && vfield(VARS[i],p)!==state.opts[p]){ok=false;break;} }
        if(ok){ variant=VARS[i]; break; } }
      items.push({value:pvv, label:pvv, price:variant?variant.price:null}); });
    dd.innerHTML='';
    dd.appendChild(khDropdown({ items:items, current:(cur||''), placeholder:'Nessuna (solo porta)',
      onPick:function(val){ state.parete=val||null; update(); } }));
  }
  function update(){
    khStickReq();
    var v=currentVariant(), recap=document.getElementById('khRecap');
    var totLbl=document.getElementById('khTotLbl'), tot=document.getElementById('khTot'), cta=document.getElementById('khCta');
    var pv=(ANGOLO?pareteVariant():null);
    if(recap){ var parts=[];
      VOPTS.forEach(function(o){ var val=state.opts[o.pos]; if(val && !isNone(val)) parts.push(val); });
      if(state.struttura) parts.push(state.struttura);
      if(state.tessuto) parts.push('Tessuto: '+state.tessuto);
      if(pv) parts.push('+ '+state.parete);
      recap.innerHTML=parts.map(function(p){return '<span>'+p+'</span>';}).join(''); }
    var q=document.getElementById('khQ'); if(q) q.textContent=state.qty;
    var qu=document.getElementById('khQUnit'); if(qu) qu.textContent=(state.qty===1?'pezzo':'pezzi');
    var nTot=state.qty*(pv?2:1); var unita=(nTot===1?'PEZZO':'PEZZI');
    if(v){ totLbl.textContent='TOTALE · '+nTot+' '+unita; tot.textContent=euro(state.qty*(v.price+(pv?pv.price:0))); }
    else { totLbl.textContent='TOTALE'; tot.textContent='—'; }
    /* comprabile solo quando tutte le opzioni sono scelte (variante risolta) + eventuale colore struttura */
    cta.disabled = !( v && (!strutturaGroupNow().length || state.struttura) );
    if(ANGOLO) refreshAngolo();
  }

  function openCartDrawer(){
    ['cart:updated','cart:refresh','cart:item-added','cart:build','ajaxCart:updated'].forEach(function(ev){ try{ document.dispatchEvent(new CustomEvent(ev,{bubbles:true})); window.dispatchEvent(new CustomEvent(ev,{})); }catch(e){} });
    var trig=document.querySelector('a[href="/cart"][data-action="open-drawer"]')||document.querySelector('[data-action="open-drawer"][data-drawer-id="sidebar-cart"]')||document.querySelector('[data-action="open-drawer"]')||document.querySelector('[data-cart-toggle], .Header__CartIcon, a[href="/cart"]');
    if(trig){ setTimeout(function(){ trig.click(); },300); return true; }
    var cd=document.querySelector('cart-drawer'); if(cd&&typeof cd.open==='function'){ cd.open(); return true; }
    return false;
  }

  root.querySelector('#khCta').addEventListener('click', function(){
    var v=currentVariant(); if(!v || (strutturaGroupNow().length && !state.struttura)){ return; }
    var cta=this; cta.disabled=true; var old=cta.innerHTML; cta.textContent='Aggiunta…';
    var props={}; if(state.struttura) props['Colore Struttura']=state.struttura; if(state.tessuto) props['Colore Tessuto']=state.tessuto;
    var pv=(ANGOLO?pareteVariant():null), items;
    if(pv){ var bundleId='angolo-'+Date.now();
      var p1={}; for(var k in props) p1[k]=props[k]; p1['Configurazione']='Doccia ad angolo'; p1['_BundleId']=bundleId;
      var p2={'Configurazione':'Doccia ad angolo','_BundleId':bundleId,'_BundleParent':String(v.id)};
      items=[{id:v.id,quantity:state.qty,properties:p1},{id:pv.id,quantity:state.qty,properties:p2}];
    } else { items=[{id:v.id,quantity:state.qty,properties:props}]; }
    function fail(){ cta.disabled=false; cta.innerHTML=old; alert('Errore aggiunta al carrello, riprova.'); }
    function add(a){ fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
      .then(function(r){ if(r.status===429&&a<6){ return setTimeout(function(){add(a+1);},700); } if(!r.ok) throw 0; return r.json().then(function(){ cta.disabled=false; cta.innerHTML=old; if(!openCartDrawer()) window.location.href='/cart'; }); })
      .catch(function(){ if(a<6) setTimeout(function(){add(a+1);},700); else fail(); }); }
    add(0);
  });

  function mount(){
    var cta=document.querySelector('.fx-cta-section'); if(!cta){ return setTimeout(mount,150); }
    var oldSel=document.getElementById('fxSanitariSelector'); if(oldSel) oldSel.style.setProperty('display','none','important');
    if(!document.getElementById('khHideOld')){ var _hs=document.createElement('style'); _hs.id='khHideOld'; _hs.textContent='#fxSanitariSelector{display:none!important}'; document.head.appendChild(_hs); }
    var origK=document.querySelector('.fx-payment-section');
    if(origK && !root.querySelector('.fx-payment-section')){
      var kc=origK.cloneNode(true); kc.classList.add('kh-klarna');
      var _li=kc.querySelector('.fx-payment-logos img'); var _lsrc=_li?_li.getAttribute('src'):'';
      var _row=kc.querySelector('.fx-payment-row'); if(_row&&_lsrc){ _row.innerHTML=_row.innerHTML.replace(/Klarna/i,'<img src="'+_lsrc+'" alt="Klarna" class="kh-klogo">'); }
      var _logos=kc.querySelector('.fx-payment-logos'); if(_logos) _logos.style.display='none';
      root.appendChild(kc); origK.remove();
    }
    if(!document.getElementById('khCfg')) cta.parentNode.insertBefore(root, cta);
    var showc=document.querySelector('.fx-product-showcase');
    if(showc && !document.getElementById('khShow')){ var sh=document.createElement('div'); sh.id='khShow';
      sh.innerHTML='<img id="khShowBg" alt="" aria-hidden="true"><img id="khShowImg" alt=""><div class="kh-show-cap" id="khShowCap"></div>'; if(ISDOCCIA) sh.classList.add('kh-fill'); showc.insertBefore(sh, showc.firstChild); }
    window.addEventListener('scroll', khStickReq, {passive:true});
    window.addEventListener('resize', khOnResize);
    var _si=document.getElementById('khShowImg'); if(_si) _si.addEventListener('load', khStickReq);
    /* costruisci step */
    revealFrom(0);
    if(stepList[0]) document.getElementById('khSec-'+stepList[0][0]).classList.add('kh-first');
    if(ANGOLO) buildAngolo();
    updateShow(); update();
  }
  if(document.readyState!=='loading') mount(); else document.addEventListener('DOMContentLoaded', mount);
})();
